import { render, staticRenderFns } from "./PillRadioButtons.vue?vue&type=template&id=619673bd&scoped=true&"
import script from "./PillRadioButtons.vue?vue&type=script&lang=js&"
export * from "./PillRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./PillRadioButtons.vue?vue&type=style&index=0&id=619673bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619673bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VBtnToggle,VIcon,VRating,VRow,VSlideXReverseTransition})
